import BaseService from './base-service.js'

const baseUrlPurchases = '/purchases/bo'

export default {
    async getStoreBaskets({ storeId }) {
        const { data } = await BaseService.get(`${baseUrlPurchases}/baskets`, {
            params: {
                storeId,
            },
        })
        return data
    },

    async getStoreActivities(params) {
        const { data } = await BaseService.get(
            `${baseUrlPurchases}/storeActivities`,
            {
                params,
            }
        )
        return data
    },

    async editProduct(productData) {
        const { data } = await BaseService.post(
            `${baseUrlPurchases}/baskets/editProduct`,
            productData
        )

        return data
    },

    async replaceProduct(productData) {
        const { data } = await BaseService.post(
            `${baseUrlPurchases}/baskets/replaceProduct`,
            productData
        )

        return data
    },

    async addProduct(productData) {
        const { data } = await BaseService.post(
            `${baseUrlPurchases}/baskets/addProduct`,
            productData
        )

        return data
    },

    async getProductsActivity(params) {
        const { data } = await BaseService.get(
            `/purchases/bo/personProductActivities`,
            {
                params,
            }
        )
        return data
    },

    async confirmResolveAIWarning(storeId, activityData) {
        const { data } = await BaseService.post(
            `/purchases/bo/${storeId}/basket/resolveAiWarning`,
            activityData
        )
        return data
    },

    async confirmResolveComplaint(storeId, personId) {
        const { data } = await BaseService.post(
            `/purchases/bo/${storeId}/basket/resolveComplaint`,
            {
                personId,
            }
        )
        return data
    },
    async basketPaymentPostpone(storeId, value) {
        const { data } = await BaseService.post(
            `/purchases/bo/${storeId}/basketPayment/postpone`,
            value
        )

        return data
    },

    async basketPaymentChargeNow(storeId, personId) {
        const { data } = await BaseService.post(
            `/purchases/bo/${storeId}/basketPayment/chargeNow`,
            {
                personId,
            }
        )

        return data
    },

    async getPurchasesList(storeId, params) {
        const { data } = await BaseService.get(
            `/purchases/bo/${storeId}/purchases`,
            {
                params,
            }
        )
        return data
    },

    async getTotalSales(storeId, period) {
        const { data } = await BaseService.get(
            `/purchases/bo/${storeId}/totalSales`,
            {
                params: {
                    period,
                },
            }
        )

        return data
    },
}
